import React from 'react';
import ReactDOM from 'react-dom';

interface HowItWorksModalProps {
  show: boolean;
  close: () => void;
  storageRequired: boolean;
}

export function HowItWorksModal({
  show,
  close,
  storageRequired,
}: HowItWorksModalProps): JSX.Element | null {
  const steps = storageRequired
    ? [
        {
          title: 'Book Your Storage',
          description:
            'Pick a date when you want us to collect your belongings. Choose your boxes and packing materials online.',
          icon: '📅',
          bgColor: '#f3f4f6',
        },
        {
          title: "We'll Collect Your Boxes",
          description:
            'On your chosen date, our friendly drivers will collect your packed boxes from your address.',
          icon: '🚚',
          bgColor: '#e0e7ff',
        },
        {
          title: 'Stored Securely',
          description:
            "We'll store your boxes in our secure, monitored warehouses with 24/7 security.",
          icon: '🏢',
          bgColor: '#ddd6fe',
        },
        {
          title: 'Ready When You Need',
          description:
            'Access your items anytime through our online portal. Schedule redelivery whenever you need your belongings back.',
          icon: '📦',
          bgColor: '#fef3c7',
        },
      ]
    : [
        {
          title: 'Book Your Shipment',
          description:
            'Select your boxes and packing materials online. Choose collection and delivery addresses for your items.',
          icon: '📅',
          bgColor: '#f3f4f6',
        },
        {
          title: "We'll Collect Your Boxes",
          description:
            'Our drivers will collect your packed boxes from your specified address on your chosen date.',
          icon: '🚚',
          bgColor: '#e0e7ff',
        },
        {
          title: 'Safe Transportation',
          description:
            'Your boxes are transported safely and securely to the destination address you specified.',
          icon: '🛣️',
          bgColor: '#ddd6fe',
        },
        {
          title: 'Delivered to Destination',
          description:
            'We deliver your boxes directly to your chosen delivery address. Track your shipment through our portal.',
          icon: '🏠',
          bgColor: '#fef3c7',
        },
      ];

  if (!show) return null;

  return ReactDOM.createPortal(
    <div className="modern-modal__overlay" onClick={close}>
      <div
        className="modern-modal__container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modern-modal__header">
          <h2>How {storageRequired ? 'Storage' : 'Shipping'} Works</h2>
          <button
            className="modern-modal__close"
            type="button"
            onClick={close}
          >
            &times;
          </button>
        </div>
        <div className="modern-modal__steps">
          {steps.map((step, index) => (
            <div
              key={index}
              className="modern-modal__step-card"
              style={{ backgroundColor: step.bgColor }}
            >
              <div className="modern-modal__step-icon">
                <span>{step.icon}</span>
                <div className="modern-modal__step-number">{index + 1}</div>
              </div>
              <div className="modern-modal__step-text">
                <h4>{step.title}</h4>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="modern-modal__footer">
          <button
            className="modern-modal__cta"
            type="button"
            onClick={close}
          >
            Got it!
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
